import React, { useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { Col, Container, Row } from 'shards-react';
import FileInput from './FileInput/FileInput';

const FileUploader = ({ uploadFile, complaintId, loading, setTempFiles }) => {
  const [files, setfiles] = useState([]);
  //   const [image, setimage] = useState([]);
  //   const [show, setshow] = useState(true);

  //   const handleCancelFileUpload = () => {
  //     setfiles([]);
  //   };

  return (
    <Container fluid>
      <LoadingOverlay active={loading} spinner>
        <Row>
          {files.length === 0 && (
            <Col md='6'>
              <FileInput setfiles={setTempFiles} />
            </Col>
          )}

          <Col>
            {files.length > 0 ? <div className='p-2'>{files[0].name}</div> : ''}

            {files.length > 0 && files[0].size >= 2000000 ? (
              <div className='text-danger'>
                File size is too big. Please try to reduce the file size.
              </div>
            ) : (
              ''
            )}
          </Col>

          {/* <Col md="6" className="floating">
						<Fragment>
							{files.length > 0 &&
							show && (
								<Card className="">
									{files[0].type === 'image/png' || files[0].type === 'image/jpeg' ? (
										<img
											className="img-preview"
											src={files[0].preview}
											style={{
												minHeight: '100px',
												minWidth: '100px',
												maxWidth: '100%',
												overflow: 'hidden',
											}}
										/>
									) : (
										<div className="p-2">{files[0].name}</div>
									)}

									<CardFooter className="home-buttons d-flex w-100 justify-content-between p-2">
										{files[0].size >= 2000000 ? (
											<div className="text-danger">
												File size is too big. Please try to reduce the file size.
											</div>
										) : (
											<Button
												theme="success"
												onClick={() => {
													setTempFiles(files);
													setshow(false);
												}}
											>
												Attach
											</Button>
										)}

										<Button onClick={() => handleCancelFileUpload()}>Cancel</Button>
									</CardFooter>
								</Card>
							)}
						</Fragment>
					</Col> */}
        </Row>
      </LoadingOverlay>
    </Container>
  );
};

export default FileUploader;
